<template>
  <div>
    <!-- Main Content of The Page -->
    <main role="main">
      <!-- Overlaying Buefy Loading Component -->
      <BLoading
        class="xb-loading"
        :is-full-page="false"
        :active.sync="isApplicationLoading"
        :can-cancel="false"
        style="z-index: 20;"
      />
    </main>
  </div>
</template>

<script>
// node modules import
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export default {
  name: "LogoutCallback",
  data() {
    return {
      mgr: new UserManager({
        userStore: new WebStorageStateStore(),
        loadUserInfo: true,
        filterProtocolClaims: true
      }),
      isApplicationLoading: true
    };
  },

  mounted() {
    this.mgr.signoutRedirectCallback().then(() => {
      this.$store.commit("auth/setSignedIn", false);
      this.$router.push({ name: "Login" });

      localStorage.removeItem("ui-internet-client");
    });
  }
};
</script>
